import React, {useEffect, useState} from "react";
import {Box, Card, CardContent, Checkbox, Pagination, Paper, Skeleton, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography,TablePagination} from "@mui/material";
import {makeStyles} from "@mui/styles";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faFileZipper} from "@fortawesome/free-solid-svg-icons";
import Tooltip from "@mui/material/Tooltip";
import {axios_tenant} from "../../../axios";
import {toast} from "react-toastify";
import { formatDate } from "app/utils/date";

const useStyles = makeStyles({
    row: {
        "&:nth-of-type(even)": {
            backgroundColor: "#ECECFF"
        }
    }
});

const TableOA = (props) => {

    let {OAdata, prepared, loading, handleDownload , clickDownload,clickUpload,setAppNo, setShowDelete,setShowDownload, confirmDelete, handleDelete,checked,setChecked} = props;

    const classes = useStyles();
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(5);

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0); // Reset to the first page
      };

    const handleCheck = e => {
        setChecked({ ...checked, [e.target.id]: e.target.checked });
    };

    useEffect(() => {
        if (clickDownload) {
            let selectedIds = Object.keys(checked).filter(key => checked[key] === true);
            handleDownload(selectedIds);
        }
        
        if (clickUpload){
        let selectedAppNo = Object.keys(checked).filter(key => checked[key] === true);
        setAppNo(selectedAppNo[0]?.replace(/[/,]/g, ''));
        }

        if (confirmDelete){
            let selectedIds = Object.keys(checked).filter(key => checked[key] === true);
            handleDelete(selectedIds);
        }

        let selectedCheckBoxes = Object.keys(checked).filter(key => checked[key] === true);

        if (selectedCheckBoxes.length === 0 ){
            setShowDownload(false);
            setShowDelete(false);
        } 
        if (selectedCheckBoxes.length === 1 ){
            setShowDownload(true);
            setShowDelete(true);
        } 
 
        if (selectedCheckBoxes.length > process.env.REACT_APP_OA_DOWNLOAD_LIMIT ){
            setShowDownload(false);
        } 

    }, [checked, clickDownload, clickUpload, confirmDelete]);


      const SkeletonLoadingCard = () => (
        <Card sx={{paddingBottom:0}}>
          <CardContent sx={{margin: 1,padding:1}} >
            <Skeleton animation="wave" />
            <Skeleton animation="wave"  />
            <Skeleton animation="wave" />
            {/* Add more skeleton elements as needed */}
          </CardContent>
        </Card>
      );

      const handleIndividualDownload = (applicationNo,fileName) => {
        {fileName.split(".")[1]==="pdf" ? 
        setRejectionLoading(prevState => ({ ...prevState, [applicationNo]: true })) : 
        setClaimsLoading(prevState => ({ ...prevState, [applicationNo]: true }))}

          axios_tenant.get(`/oa/individual-download`, {
                params: {
                    applicationNo,fileName
                },
                responseType: 'arraybuffer'
            })
            .then((res)=>{
                {fileName.split(".")[1]==="pdf" ? 
                setRejectionLoading(prevState => ({ ...prevState, [applicationNo]: false })) : 
                setClaimsLoading(prevState => ({ ...prevState, [applicationNo]: false }))}

               const blob = new Blob([res.data], { type: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document' });
              const url = window.URL.createObjectURL(blob);
            
              const a = document.createElement('a');
              a.style.display = 'none';
              a.href = url;
              a.download = fileName; 
              document.body.appendChild(a);
        
              a.click();
        
              toast.success(`${fileName.split(".")[0]} file downloaded`); 
              window.URL.revokeObjectURL(url);
              document.body.removeChild(a);
            })
            .catch(err =>{
                {fileName.split(".")[1]==="pdf" ? 
                setRejectionLoading(prevState => ({ ...prevState, [applicationNo]: false })) : 
                setClaimsLoading(prevState => ({ ...prevState, [applicationNo]: false }))}
                toast.error("Download failed"); 
            })  
    
      };

    return (
        <>
       
            <TableContainer component={Paper}>
                <Table size="small">
                    <TableHead sx={{ backgroundColor: "#010160" }}>
                        <TableRow>
                            <TableCell sx={{ color: "white" }}> </TableCell>
                            <TableCell sx={{ color: "white" }}>App No.</TableCell>
                            <TableCell sx={{ color: "white" }}>Rejection Type</TableCell>
                            {/* <TableCell sx={{ color: "white" }}>Status</TableCell> */}
                            <TableCell sx={{ color: "white" }}>Mail Room Date</TableCell>
                            {prepared && <TableCell sx={{ color: "white" }}>Prepared Date</TableCell>}
                            <TableCell>{" "}</TableCell>
                            {/* <TableCell>{" "}</TableCell> */}
                        </TableRow>
                    </TableHead>
                    
                    <TableBody>

                        {OAdata?.slice((page) * rowsPerPage, (page) * rowsPerPage + rowsPerPage)?.map((p, i) => (
                            <TableRow key={p.id} className={classes.row}>
                                <TableCell>
                                    <Checkbox id={p.id} checked={checked[p.id] || false} onChange={e => handleCheck(e)} />
                                </TableCell>

                                <TableCell>{p.applicationNo}</TableCell>
                                <TableCell>{p.rejectionType}</TableCell>
                                {/* <TableCell>{p.status}</TableCell> */}
                               
                                <TableCell>{formatDate(p.mailRoomDate)}</TableCell>
                                {prepared && p.preparedDate && <TableCell>{formatDate(p.preparedDate)}</TableCell>}
                                {prepared && !p.preparedDate && <TableCell>---</TableCell>}
                                
                                <TableCell>
                                    <Tooltip title={p.rejectionType==="Final" ? `${p.applicationNo}_Res_to_FOA` : `${p.applicationNo}_Res_to_NFOA`}>
                                       
                                        <FontAwesomeIcon icon={faFileZipper} size="2x" style={{cursor:"pointer"}} onClick={()=> handleDownload([p.id])} />
                                    </Tooltip>
                                </TableCell>
                               
                               
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>
            <br></br>
            {(OAdata?.length===0 && !loading) && <Typography variant="h4" justifyContent="center">No data available, Click "Upload Files" button to add a new application</Typography>}
        
            {OAdata?.length>0 && <Box display="flex" justifyContent="flex-end" alignItems="center">
                <TablePagination rowsPerPageOptions={[5, 10, 25]} 
                sx={{
                    ".MuiTablePagination-displayedRows": {
                        marginTop: "1em",
                        marginBottom: "1em",
                      },
                      ".MuiTablePagination-selectLabel": {
                        marginTop: "1em",
                        marginBottom: "1em",
                      },
                      ".MuiTablePagination-actions": {
                        marginTop: "1em",
                        marginBottom: "1em",
                      },
                      ".MuiTablePagination-toolbar": {
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                      },
                  }}
              
                count={OAdata.length} 
                rowsPerPage={rowsPerPage}
                page={page} 
                onPageChange={handleChangePage} 
                onRowsPerPageChange={handleChangeRowsPerPage} 
                />
            </Box>}
        </>
    );
};

// .pagination-toolbar {
//     display: flex;
//     justify-content: space-between;
//     align-items: center;
//   }
export default TableOA;